import { useNodes } from 'reactflow';
import { useMemo } from 'react';
import { uniq } from 'lodash-es';
import type { UIOption } from 'store/options';
import type { NodeData } from 'store/interfaces';

export default function useFormMultipleValueOptions(
  fieldName: keyof NodeData,
): UIOption[] {
  const node = useNodes<NodeData>();

  return useMemo(() => {
    const uniqueValues = uniq(
      node
        .filter((item) => item.data?.[fieldName])
        .flatMap(({ data }) => data[fieldName] as string[]),
    );

    return uniqueValues.map((value) => ({ id: value, name: value }));
  }, [node, fieldName]);
}
